"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLEBeaconClassifierNode = void 0;
const core_1 = require("@openhps/core");
const data_1 = require("../data");
class BLEBeaconClassifierNode extends core_1.ObjectProcessingNode {
    constructor(options) {
        var _a;
        super(options);
        this.options.objectFilter =
            (_a = this.options.objectFilter) !== null && _a !== void 0 ? _a : ((object) => object instanceof data_1.BLEObject && object.rawAdvertisement !== undefined);
    }
    processObject(object, frame) {
        return new Promise((resolve) => {
            let output = object;
            for (let i = 0; i < this.options.types.length; i++) {
                const BeaconType = this.options.types[i];
                const beaconObject = object.clone(BeaconType);
                // Parse advertisement if raw available
                if (beaconObject.rawAdvertisement) {
                    beaconObject.parseAdvertisement(beaconObject.rawAdvertisement);
                }
                else {
                    // Parse manufacturer data
                    if (beaconObject.manufacturerData && beaconObject.manufacturerData.size > 0) {
                        beaconObject.manufacturerData.forEach((data, manufacturer) => {
                            beaconObject.parseManufacturerData(manufacturer, data);
                        });
                    }
                    // Parse service data
                    if (beaconObject.services && beaconObject.services.length > 0) {
                        beaconObject.services.forEach((service) => {
                            beaconObject.parseServiceData(service.uuid, service.data);
                        });
                    }
                }
                if (beaconObject.isValid()) {
                    // Accept beacon and replace
                    const prevUID = beaconObject.uid;
                    if (this.options.resetUID) {
                        beaconObject.uid = beaconObject.computeUID();
                    }
                    // Rename relative uids
                    if (frame.source && beaconObject.uid !== prevUID) {
                        const positions = frame.source.getRelativePositions(prevUID);
                        positions.forEach((relPos) => {
                            relPos.referenceObjectUID = beaconObject.uid;
                            frame.source.addRelativePosition(relPos);
                        });
                        frame.source.removeRelativePositions(prevUID);
                    }
                    output = beaconObject;
                    break;
                }
            }
            resolve(output);
        });
    }
}
exports.BLEBeaconClassifierNode = BLEBeaconClassifierNode;
//# sourceMappingURL=BLEBeaconClassifierNode.js.map